export const formatCurrency = (value) => {
  if (!value) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
export const parseMoney = (formattedValue) => Number(formattedValue.replace(/\./g, '')) || 0;
